import { createTheme, type Theme } from '@mui/material'

import { breakpoints, dropShadows, gradients, radius, shadows } from './design-tokens'
import { themePalette } from './palette'
import { themeTypography } from './typography'

export * from './palette'
export * from './utils/scroll-masks'
export * from './utils/scroll-utils'

/**
 * The theme survives FE-662 for exactly one reason: `cssVariables` below emits
 * the unprefixed `--palette-*` custom properties that ~125 call sites read, and
 * nothing else in the tree defines them. Until those are emitted from the design
 * tokens directly, `ThemeProvider` has to stay mounted at the app roots.
 *
 * The `components` overrides are gone. They only ever styled MUI components, and
 * no MUI component renders any more, so nothing could receive them.
 */
export const createGtoTheme = (): Theme =>
  createTheme({
    //@ts-expect-error MUI typings bug https://mui.com/material-ui/customization/css-theme-variables/configuration/
    cssVariables: { cssVarPrefix: '' },
    palette: {
      ...themePalette,
    },

    gradients,
    radius,
    breakpoints: {
      values: breakpoints,
    },
    paperShadows: shadows,
    typography: { ...themeTypography },
    dropShadows,
  })
